export const getSEO = async (pageName) => {
  try {
    const formData = new FormData();
    formData.append("page_name", pageName);

    const response = await fetch(
      "https://idealtechnoride.in/api/seo",
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.json();

    return result.length > 0 ? result[0] : null;
  } catch (error) {
    console.error("SEO Error:", error);
    return null;
  }
};